import React from "react";

// MATERIAL UI COMPONENTS
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { LightGreyBox } from "../styled";

export default function AddressForm({
  cep,
  street,
  houseNumber,
  neighborhood,
  complement,
  reference,
  city,
  uf,
  setCep,
  setStreet,
  setHouseNumber,
  setNeighborhood,
  setComplement,
  setReference,
  setCity,
  setUf,
  searchCep,
  showDataWarning = true,
}) {
  return (
    <LightGreyBox>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          mb: 1,
        }}
      >
        {showDataWarning && (
          <Grid item xs={12}>
            <Typography
              id="address-use-cases-infos"
              variant="caption"
              align="center"
            >
              Fique tranquilo(a), nenhuma informação será compartilhada com os
              clientes. Esses dados serão usados apenas internamente, para
              calcular rotas e facilitar integrações, como o Entrega Fácil e
              outras.
            </Typography>
            <Divider variant="middle" sx={{ my: 2 }} />
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={3}>
          <TextField
            id="cep"
            size="small"
            label="CEP"
            onBlur={searchCep}
            variant="filled"
            fullWidth
            value={cep}
            onChange={(e) => setCep(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <TextField
            id="street"
            size="small"
            label="Rua"
            variant="filled"
            fullWidth
            value={street}
            onChange={(e) => setStreet(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <TextField
            id="houseNumber"
            size="small"
            label="Número"
            variant="filled"
            fullWidth
            value={houseNumber}
            onChange={(e) => setHouseNumber(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12} sm={12} md={3}>
          <TextField
            id="neighborhood"
            size="small"
            label="Bairro"
            variant="filled"
            fullWidth
            value={neighborhood}
            onChange={(e) => setNeighborhood(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <TextField
            id="city"
            size="small"
            label="Cidade"
            variant="filled"
            fullWidth
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <TextField
            id="uf"
            size="small"
            label="Estado"
            variant="filled"
            fullWidth
            value={uf}
            onChange={(e) => setUf(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          my: 1,
        }}
      >
        <Grid item xs={12} sm={12} md={4}>
          <TextField
            id="complement"
            size="small"
            label="Complemento"
            variant="filled"
            fullWidth
            value={complement}
            onChange={(e) => setComplement(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5}>
          <TextField
            id="reference"
            size="small"
            label="Referência"
            variant="filled"
            fullWidth
            value={reference}
            onChange={(e) => setReference(e.target.value)}
          />
        </Grid>
      </Grid>
    </LightGreyBox>
  );
}
